// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/common.scss';
import '@/assets/css/style.scss';
import './assets/font/iconfont.css';
import { HttpPlugin } from '@/api/plugin';

Vue.use(Vant);
Vue.use(HttpPlugin);

Vue.config.productionTip = false;

Vue.mixin({
  filters: {
    formatTime(str) {
      if (!str) return '无日期';
      return str.slice(0, 10);
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js